<template>
  <div
    class="bg-gray-50 pt-20 pb-28"
    :class="[
      options.color === 'green' ? 'bg-lightGreenBg' : '',
      options.spacing === 'small' ? 'mt-6 lg:mt-10' : '',
      options.spacing === 'large' ? 'mt-12 lg:mt-20' : '',
    ]"
  >
    <div class="grid-container">
      <div class="col-span-4 sm:col-span-6 md:col-span-8 lg:col-span-12">
        <BlokkliField :list="header" name="field_header" />

        <BlokkliField
          :list="paragraphs"
          name="field_content"
          tag="ul"
          :class="listClasses"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphLinkListFragment } from '#graphql-operations'

const { options } = defineBlokkli({
  bundle: 'link_list',
  editor: {
    editTitle: (el) => el.querySelector('a')?.innerText,
  },
  globalOptions: ['spacing'],
  options: {
    color: {
      type: 'radios',
      label: 'Hintergrundfarbe',
      default: 'gray',
      displayAs: 'colors',
      options: {
        gray: { class: 'bg-gray-300', label: 'Grau' },
        green: { class: 'bg-lightGreen', label: 'Grün' },
      },
    },
  },
  propsFieldMapping: {
    header: 'field_header',
    paragraphs: 'field_content',
  },
})

defineProps<{
  header?: ParagraphLinkListFragment['header']
  paragraphs?: ParagraphLinkListFragment['paragraphs']
}>()

defineOptions({
  name: 'ParagraphLinkList',
})

const listClasses = [
  'flex',
  'flex-wrap',
  'justify-center',
  'gap-8',
  'list-none',
  'p-0',
  '[&>li]:inline-flex',
  '[&>li]:flex-none',
  '[&>li]:w-[396px]',
  '[&>li>a]:w-full',
  '[&:has(>li:nth-child(3))]:!grid',
  '[&:has(>li:nth-child(3))]:grid-cols-1',
  'sm:[&:has(>li:nth-child(3))]:grid-cols-2',
  'md:[&:has(>li:nth-child(3))]:grid-cols-3',
  '[&:has(>li:nth-child(3))]:gap-6',
  'sm:[&:has(>li:nth-child(3))]:gap-x-8',
  'md:[&:has(>li:nth-child(3))]:gap-x-12',
  '[&:has(>li:nth-child(3))]:justify-items-center',
]
</script>
